// TabletShowcase.js
import { useState, useEffect } from "react";

const TabletShowcase = () => {
	// Array of complete tablet images (tablet frame + screenshot composited together)
	const tabletImages = [
		"/tablet-simulations.png",
		"/tablet-dashbud.png",
		"/tablet-video.png",
		"/tablet-app.png",
	];

	const [currentImage, setCurrentImage] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentImage((prev) => (prev + 1) % tabletImages.length);
		}, 3000);

		return () => clearInterval(interval);
	}, [tabletImages.length]);

	return (
		<div
			className="tablet-3d-container"
			style={{
				perspective: "1200px",
				width: "100%",
				height: "500px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<div
				className="tablet-floating"
				style={{
					width: "520px",
					height: "380px",
					position: "relative",
					animation: "floatTilt 6s ease-in-out infinite",
				}}
			>
				<img
					src={tabletImages[currentImage]}
					alt={`Project ${currentImage + 1}`}
					style={{
						width: "100%",
						height: "100%",
						objectFit: "contain",
						filter: "drop-shadow(0 20px 40px rgba(0, 0, 0, 0.3))",
						transition: "opacity 0.5s ease-in-out",
					}}
				/>
			</div>

			<style>{`
				@keyframes floatTilt {
					0%, 100% {
						transform: translateY(0px) translateX(0px) rotateX(-5deg) rotateY(-8deg) rotateZ(-2deg);
					}
					25% {
						transform: translateY(-15px) translateX(10px) rotateX(-3deg) rotateY(-5deg) rotateZ(1deg);
					}
					50% {
						transform: translateY(-8px) translateX(-5px) rotateX(-7deg) rotateY(-10deg) rotateZ(-3deg);
					}
					75% {
						transform: translateY(-12px) translateX(8px) rotateX(-4deg) rotateY(-6deg) rotateZ(0deg);
					}
				}
			`}</style>
		</div>
	);
};

export default TabletShowcase;
